import type { Middleware, AnyAction } from '@reduxjs/toolkit';
import type { UnassignedTasksDisplayDateRange } from '~/reducers/unassignedTasksDisplayDateRange';
import { getAllTasks } from '~/reducers/tasksSlice';
import type { SelectedClientState } from '~/reducers/selectedClientsSlice';
import dateUtils from '~/utils/date-utils';
import constants from '~/utils/constants';

interface PartialState {
    /**
     * Selected client ids managed by selectedClientSlice
     */
    selectedClients: SelectedClientState;
    /**
     * Start and end date to display unassigned tasks managed by unassignedTasksDisplayDateRangeSlice
     */
    unassignedTasksDisplayDateRange: UnassignedTasksDisplayDateRange;
}

export const requestUnassignedTasksForDateRangeMiddleware: Middleware<
    unknown,
    PartialState
> = (store) => (next) => (action) => {
    const ACTIONS: Record<string, boolean> = {
        'unassignedTasksDisplayDateRange/setUnassignedTasksDisplayDateRange':
            true
    };

    const result = next(action);

    const currentDateRange = store.getState().unassignedTasksDisplayDateRange;
    const selectedClientIds = Object.keys(store.getState().selectedClients);

    if (!currentDateRange) {
        return result;
    }

    const dates = dateUtils.getDateRangeFromStartAndEnd(currentDateRange);

    if (ACTIONS[action.type]) {
        dates.forEach((date) => {
            store.dispatch(
                getAllTasks({
                    routeDate: date as string,
                    status: [constants.taskStatus.UNASSIGNED],
                    limit: constants.onDemandDispatch.API_RESPONSE_LIMIT,
                    selectedClientIds
                }) as unknown as AnyAction
            );
        });
    }

    return result;
};
